import type { Folder } from "../api";
import type { SelectOption } from "../components/Select";

const SONDERNAMEN: Record<string, string> = {
  "\\Inbox": "Posteingang",
  "\\Sent": "Gesendet",
  "\\Drafts": "Entwürfe",
  "\\Archive": "Archiv",
  "\\Junk": "Unerwünscht",
  "\\Trash": "Papierkorb",
};

/** Anzeigename eines Ordners: Systemordner deutsch, sonst der eigene Name. */
export function ordnerName(f: Folder): string {
  if (f.special_use && SONDERNAMEN[f.special_use]) return SONDERNAMEN[f.special_use]!;
  if (f.path.toUpperCase() === "INBOX") return "Posteingang";
  return f.name;
}

/** Voller Pfad zum Anzeigen: „Posteingang / Kunden / System4". */
export function ordnerPfad(f: Folder, alle: Folder[]): string {
  if (!f.delimiter) return ordnerName(f);
  const teile = f.path.split(f.delimiter);
  const namen: string[] = [];
  for (let i = 1; i <= teile.length; i++) {
    const pfad = teile.slice(0, i).join(f.delimiter);
    const g = alle.find((x) => x.account_id === f.account_id && x.path === pfad);
    namen.push(g ? ordnerName(g) : teile[i - 1]!);
  }
  return namen.join(" / ");
}

/**
 * Auswahl für „Verschieben nach": nur Ordner des passenden Kontos — ein Pfad
 * aus einem anderen Postfach führt auf dem Server ins Leere.
 */
export function ordnerOptionen(folders: Folder[], accountId?: number | null, ohne?: number): SelectOption[] {
  return folders
    .filter((f) => (accountId == null || f.account_id === accountId) && f.id !== ohne)
    .map((f) => ({ f, label: ordnerPfad(f, folders), rang: ordnerRang(f, folders) }))
    .sort((a, b) => a.rang - b.rang || a.label.localeCompare(b.label, "de", { sensitivity: "base" }))
    .map(({ f, label }) => ({ value: f.path, label }));
}

const REIHENFOLGE = ["\\Inbox", "\\Sent", "\\Drafts", "\\Archive", "\\Junk", "\\Trash"];

/** Systemordner (samt Unterordnern) in fester Folge vorn, alles andere danach. */
export function ordnerRang(f: Folder, alle: Folder[]): number {
  const wurzelPfad = f.delimiter ? f.path.split(f.delimiter)[0]! : f.path;
  const wurzel = alle.find((g) => g.account_id === f.account_id && g.path === wurzelPfad) ?? f;
  const i = wurzel.special_use ? REIHENFOLGE.indexOf(wurzel.special_use) : wurzel.path.toUpperCase() === "INBOX" ? 0 : -1;
  return i === -1 ? 99 : i;
}
